import { Button } from "@chakra-ui/react";
import SvgContainer from "src/components/SvgContainer";

export default function IconAsButton({
  icon,
  fill = "mediumEmphasis",
  size,
  activeBg,
  hoverBg,
  ...rest
}) {
  return (
    <Button
      variant="custom"
      bg="transparent"
      border="none"
      borderRadius="100%"
      transition="background 0.3s"
      _active={{
        bg: activeBg || "iconBackground"
      }}
      _hover={{
        bg: hoverBg || "hover"
      }}
      p="4px"
      {...rest}
    >
      <SvgContainer icon={icon} fill={fill} size={size} />
    </Button>
  );
}
